export default __webpack_public_path__ + "static/Pardeep-Meghwar-197756b410bbc31b75f2e6a14eaf239f.png";